import { Table, Tabs, Typography } from 'antd';
import i18n from 'i18next';
import { FC, memo, useState } from 'react';

import { ColumnTypes, ProjectPaymentSchedule } from 'models';

import { useTranslate } from 'hooks';

import Utils from 'utils/utils';
import { PaymentStatus } from 'utils/constants';

import { TableItemStatus } from 'componets/ui';

const columns = [
	{
		title: i18n.t('paymentDateText'),
		dataIndex: 'paymentDate',
	},
	{
		title: i18n.t('principalPaymentText'),
		dataIndex: 'principalAmount',
		render: (amount: number) => {
			return Utils.moneyFormat(amount);
		},
	},
	{
		title: i18n.t('interestPaymentText'),
		dataIndex: 'interestAmount',
		render: (amount: number) => {
			return Utils.moneyFormat(amount);
		},
	},
	{
		title: i18n.t('paymentStatusText'),
		dataIndex: 'status',
		render: (status: string) => {
			return (
				<TableItemStatus
					status={status}
					isRed={status === PaymentStatus.LATE || status === PaymentStatus.PAY_WITH_DELAY}
					isGreen={status === PaymentStatus.PAID}
				/>
			);
		},
	},
];

export const PrimaryItemPaymentSchedule: FC<{
	data: ProjectPaymentSchedule[];
	archive: ProjectPaymentSchedule[][];
}> = memo(({ data, archive }) => {
	const { paymentScheduleText, activeText, versionText } = useTranslate([
		'paymentScheduleText',
		'activeText',
		'versionText',
	]);

	const [type, setType] = useState('active');

	const reversedArchive = Utils.reverseMatrix(archive);
	return (
		<div className="primaryItem__block">
			<Typography.Title className="primaryItem__blockTitle" level={4}>
				{paymentScheduleText}
			</Typography.Title>

			{archive.length > 0 ? (
				<Tabs
					className="accountTabs"
					type="card"
					defaultActiveKey="active"
					activeKey={type}
					onChange={(v: string) => setType(v)}
					destroyInactiveTabPane
				>
					<Tabs.TabPane tab={activeText} key="active">
						<ActiveSchedule data={data} />
					</Tabs.TabPane>

					{reversedArchive.map((item, index) => {
						return (
							<Tabs.TabPane tab={`${versionText} ${item[0]?.version}`} key={index}>
								<Table
									className="accountTable accountTable__paymentSchedule"
									columns={columns as ColumnTypes}
									dataSource={item}
									pagination={false}
									scroll={{ x: 670 }}
								/>
							</Tabs.TabPane>
						);
					})}
				</Tabs>
			) : (
				<ActiveSchedule data={data} />
			)}
		</div>
	);
});

export const ActiveSchedule: FC<{ data: ProjectPaymentSchedule[] }> = ({ data }) => {
	const { noPaymentScheduleText } = useTranslate(['noPaymentScheduleText']);

	return (
		<>
			{data.length > 0 ? (
				<Table
					className="accountTable accountTable__paymentSchedule"
					columns={columns as ColumnTypes}
					dataSource={data}
					pagination={false}
					scroll={{ x: 670 }}
				/>
			) : (
				<Typography.Text className="primaryItem__text">{noPaymentScheduleText}</Typography.Text>
			)}
		</>
	);
};
